import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { I18nProvider, useI18n, DEFAULT_LANG, SUPPORTED } from "./i18n/I18nContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import TermsConditions from "./pages/TermsConditions";
import ThankYou from "./pages/ThankYou";

function DocumentHead() {
  const { t, lang } = useI18n();
  const location = useLocation();

  useEffect(() => {
    document.documentElement.lang = lang;
    let title = t("meta.home_title");
    if (location.pathname.endsWith("/privacy")) title = t("meta.privacy_title");
    else if (location.pathname.endsWith("/cookies")) title = t("meta.cookie_title");
    else if (location.pathname.endsWith("/terms")) title = t("meta.terms_title");
    document.title = title;

    let desc = document.querySelector('meta[name="description"]');
    if (!desc) {
      desc = document.createElement("meta");
      desc.setAttribute("name", "description");
      document.head.appendChild(desc);
    }
    desc.setAttribute("content", t("meta.home_description"));
  }, [lang, location.pathname, t]);

  return null;
}

function LocalizedShell() {
  return (
    <>
      <DocumentHead />
      <Header />
      <Routes>
        <Route index element={<Home />} />
        <Route path="privacy" element={<PrivacyPolicy />} />
        <Route path="cookies" element={<CookiePolicy />} />
        <Route path="terms" element={<TermsConditions />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
      <CookieBanner />
    </>
  );
}

function LangGuard({ children }) {
  const location = useLocation();
  const seg = location.pathname.split("/").filter(Boolean)[0];
  if (!SUPPORTED.includes(seg)) {
    return <Navigate to={`/${DEFAULT_LANG}`} replace />;
  }
  return children;
}

function Root() {
  return (
    <I18nProvider>
      <ScrollToTop />
      <Routes>
        <Route path="/thank_you" element={<ThankYou />} />
        <Route path="/ar/*" element={<LocalizedShell />} />
        <Route path="/en/*" element={<LocalizedShell />} />
        <Route path="/" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
        <Route
          path="*"
          element={
            <LangGuard>
              <LocalizedShell />
            </LangGuard>
          }
        />
      </Routes>
    </I18nProvider>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Root />
      </BrowserRouter>
    </div>
  );
}

export default App;
